// International Soccer Leagues and Competitions
export const SOCCER_LEAGUES = [
  // European Leagues
  'ინგლისი პრემიერლიგა',
  'ინგლისი ჩემპიონშიპი',
  'ესპანეთი ლა ლიგა',
  'ესპანეთი ლა ლიგა 2',
  'გერმანია ბუნდესლიგა',
  'გერმანია 2 ბუნდესლიგა',
  'იტალია სერია ა',
  'საფრანგეთის ლიგა 1',
  'აუსტრია ბუნდესლიგა',
  'ბელგია იუპილერ ლიგა',
  'ნიდერლანდები ერედივიზიონი',
  'ნიდერლანდები ერსტე დივიზიონი',
  'შოტლანდია პრემიერშიპი',
  'ა.შ.შ მლს',
  'ნორვეგია ელიტსერიენი',
  'პორტუგალიის ლიგა',
  'თურქეთი სუპერ ლიგა',
  'შვეიცარია სუპერ ლიგა',
  'შვეიცარია ჩელენჯ ლიგა',
  'საუდის არაბეთი პროფედიონალური ლიგა',
  'უნგრეთი  NB I.',
  'დანია სუპერლიგა',
  'შვედეთი ოლსვენკა',
  'რუმინეთი სუპერლიგა',
  'უკრაინა პრემიერ ლიგა',
  'ირლანდია პრემიერ დივიზიონი',
  'ჩეხეთი 1. ლიგა',
  'საბერძნეთი სუპერ ლიგა',
  'კვიპროსი I დივიზიონი',
  'ისრაელი პრემიერლიგა',
  'სლოვაკეთი სუპერლიგა',
  'ხორვატია HNL',
  'ბრაზილია სერია ა',
  'არგენტინა პრიმერა დივიზიონი'
];

export const SOCCER_CLUBS = {
  'ინგლისი პრემიერლიგა': [
    'არსენალი',
    'ასტონ ვილა',
    'ბორნმუთი',
    'ბრენტფორდი',
    'ბრაიტონი',
    'ბარნლი',
    'ჩელსი',
    'კრისტალ პალასი',
    'ევერტონი',
    'ფულემი',
    'ლივერპული',
    'ლიდს იუნაიტედი',
    'ლესტერ სიტი',
    'მანჩესტერ სიტი',
    'მანჩესტერ იუნაიტედი',
    'ნიუკასლ იუნაიტედი',
    'ნოტინგემ ფორესტი',
    'სანდერლენდი',
    'ტოტენჰემი',
    'ვესტ ჰემი'
  ],
  'ესპანეთი ლა ლიგა': [
    'ალავესი',
    'ატლეტიკო მადრიდი',
    'ატლეტიკ ბილბაო',
    'ბარსელონა',
    'სელტა',
    'ხეტაფე',
    'ხირონა',
    'გრანადა',
    'ლას პალმასი',
    'ლეგანესი',
    'მალაგა',
    'მალიორკა',
    'ოსასუნა',
    'რაიო ვალიეკანო',
    'რეალ ბეტისი',
    'რეალ მადრიდი',
    'რეალ სოსიედადი',
    'სევილია',
    'ვალენსია',
    'ვილიარეალი'
  ],
  'გერმანია ბუნდესლიგა': [
    'აუგსბურგი',
    'ბაიერ ლევერკუზენი',
    'ბაიერნი',
    'ბოხუმი',
    'დორტმუნდი',
    'აინტრახტ ფრანკფურტი',
    'ფრაიბურგი',
    'ჰოფენჰაიმი',
    'ჰერტა',
    'კელნი',
    'მაინცი',
    'მიონხენგლადბახი',
    'რბ ლაიფციგი',
    'შალკე 04',
    'შტუტგარტი',
    'უნიონ ბერლინი',
    'ვერდერ ბრემენი',
    'ვოლფსბურგი'
  ],
  'იტალია სერია ა': [
    'ატალანტა',
    'ბოლონია',
    'კრემონეზე',
    'ემპოლი',
    'ფიორენტინა',
    'ფროზინონე',
    'ჰელას ვერონა',
    'ინტერ მილანი',
    'იუვენტუსი',
    'ლაციო',
    'ლეჩე',
    'მილანი',
    'ნაპოლი',
    'პარმა',
    'რომა',
    'ტორინო',
    'უდინეზე',
    'ვენეცია',
    'პიზა'
  ],
  'საფრანგეთის ლიგა 1': [
    'ანჟე',
    'აუქსერი',
    'ბრესტი',
    'ლანსი',
    'ლილი',
    'ლორიანი',
    'ლიონი',
    'მარსელი',
    'მონაკო',
    'მეცი',
    'ნანტი',
    'ნიცა',
    'პარი ფსჟ',
    'პარი ფსი',
    'რეიმსი',
    'რენი',
    'სტრასბურგი',
    'ტულუზა'
  ],
  'აუსტრია ბუნდესლიგა': [
    'ალტახი',
    'აუსტრია ვენა',
    'აუსტრია კლაგენფურტი',
    'ჰარტბერგი',
    'ლასკი',
    'რაპიდ ვენა',
    'რიდი',
    'ზალცბურგი',
    'შტურმ გრაცი',
    'ვოლფსბერგერი',
    'ვსგ ტიროლი',
    'ბლაუ-ვაის ლინც'
  ],


  'პორტუგალიის ლიგა': [
    'აროუკა',
    'ავეში',
    'ბენფიკა',
    'ბრაგა',
    'ეშტორილ-პრაია',
    'ფამალიკანი',
    'ფარენსე',
    'გილ-ვისენტე',
    'მორეირენსე',
    'ნასიონალი',
    'პორტიმონენსე',
    'პორტუ',
    'რიუ-ავე',
    'სანტა-კლარა',
    'სპორტინგი',
    'ტონდელა',
    'ვიტორია დე გიმარაიში'
  ],
  'თურქეთი სუპერ ლიგა': [
    'ადანადემირსპორი',
    'ალანიასპორი',
    'ანტალიასპორი',
    'ბეშიქთაში',
    'ბოდრუმსპორი',
    'ჩაიკურ რიზესპორი',
    'ეიუფსპორი',
    'ფატიჰ ქარაგიუმრიუქი',
    'ფენერბაჰჩე',
    'გაზიანტეფი',
    'გაზიშეჰირ გაზიანტეფი',
    'გალათასარაი',
    'ჰაჯეტეფე',
    'კაისერისპორი',
    'კასიმფაშა',
    'ქოჯაელისპორი',
    'სივასპორი',
    'ტრაბზონსპორი',
    'ალთაი',
    'ოსმანლისპორი'
  ],
  'ირლანდია პრემიერ დივიზიონი': [
    'ბოჰემიანსი',
    'დერი სიტი',
    'დროგედა',
    'გოლუეი',
    'შელბოურნი',
    'შემროკ როვერსი',
    'სლაიგო როვერსი',
    'სენტ-პატრიკი',
    'უოტერფორდი',
    'დუნდალკი'
  ],
  'ჩეხეთი 1. ლიგა': [
    'ბანიკ ოსტრავა',
    'ბრნო',
    'ცესკე ბუდეიოვიცე',
    'დრაცოვიცე',
    'იაბლონეცი',
    'კარვინა',
    'კლადნო',
    'მლადა-ბოლესლავი',
    'ოლომოუცი',
    'პლზენი',
    'პრშიბრამი',
    'სლავია პრაღა',
    'სპარტა პრაღა',
    'ტეპლიცე',
    'ვისოჩინა',
    'ზლინი'
  ],
  'შვეიცარია სუპერ ლიგა': [
    'ბაზელი',
    'გრასჰოფერი',
    'ლუგანო',
    'ლუცერნი',
    'ლოზანა',
    'სერვეტი',
    'სიონი',
    'სანქტ-გალენი',
    'თუნი',
    'იანგ ბოიზი'
  ],
  'ინგლისი ჩემპიონშიპი': [
    'ბლეკბერნი',
    'ბრისტოლ სიტი',
    'კარდიფი',
    'კოვენტრი',
    'დერბი',
    'ჰალ სიტი',
    'ლიდს იუნაიტედი',
    'ლესტერ სიტი',
    'მილუოლი',
    'ნორიჯი',
    'ოქსფორდ იუნაიტედი',
    'პლიმუთი',
    'პრესტონი',
    'ქუინზ პარკ რეინჯერსი',
    'შეფილდ უენსდეი',
    'შეფილდ იუნაიტედი',
    'საუთჰემპტონი',
    'სტოკ სიტი',
    'სუონსი',
    'ვესტ ბრომვიჩი',
    'უოტფორდი'
  ],



  'ბელგია იუპილერ ლიგა': [
    'ანდერლეხტი',
    'ანტვერპენი',
    'ბრეინდე',
    'სერკლი ბრიუგე',
    'კლუბ ბრიუგე',
    'შარლერუა',
    'დენდერი',
    'გენტი',
    'ლაუვიერი',
    'ლეუვენი',
    'მეხელენი',
    'ოსტენდე',
    'სენტ-ტრუიდენი',
    'სტანდარდ ლიეჟი',
    'იუნიონ სენტ-ჟილოიზე',
    'ვესტერლო'
  ],
  'ნიდერლანდები ერედივიზიონი': [
    'აიაქსი',
    'ალმერე სიტი',
    'აზ ალკმარი',
    'ექსელსიორი',
    'ფეიენოორდი',
    'გრონინგენი',
    'ჰერენვეენი',
    'კამბური',
    'ნეიმეგენი',
    'პსვ',
    'რაინდამსდალვიკი',
    'სპარტა როტერდამი',
    'ტვენტე',
    'უტრეხტი',
    'ვოლენდამი',
    'ვილემ II',
    'ჰერაკლესი'
  ],
  'ესპანეთი ლა ლიგა 2': [
    'ალბასეტე',
    'ალმერია',
    'ალკორკონი',
    'ამორებიეტა',
    'ბურგოსი',
    'კარტახენა',
    'ელჩე',
    'ეიბარი',
    'ესპანიოლი',
    'ფუენლაბრადა',
    'ხიმნასტიკი',
    'ლას პალმასი',
    'ლევანტე',
    'ლოგრონიესი',
    'მალაგა',
    'მირანდესი',
    'ოვიედო',
    'პონფერადინა',
    'რასინგ სანტანდერი',
    'სპორტინგ ხიხონი',
    'ტენერიფე',
    'ვალენსია B',
    'ვილიარეალ B',
    'სარაგოსა'
  ],
  'გერმანია 2 ბუნდესლიგა': [
    'დარმშტადტი',
    'ჰანზა როსტოკი',
    'ჰერტა B',
    'კარლსრუე',
    'კაიზერსლაუტერნი',
    'მაგდებურგი',
    'ნიურნბერგი',
    'პადერბორნი',
    'ჰანოვერი',
    'ოსნაბრიუკი',
    'შალკე 04',
    'ელვერსბერგი',
    'ინგოლშტადტი',
    'ბრაუნშვაიგი',
    'ვეიენი',
    'ზანდჰაუზენი',
    'რეგენსბურგი'
  ],
  'ნიდერლანდები ერსტე დივიზიონი': [
    'ადო დენ ჰააგი',
    'ამერსფორტი',
    'კამბური',
    'დენ ბოსხი',
    'დორდრეხტი',
    'ეინდჰოვენი',
    'ემენი',
    'გრონინგენი',
    'ჰელმონდი',
    'იონგ პსვ',
    'იონგ აზ',
    'იონგ უტრეხტი',
    'მაასტრიხტი',
    'ნაიმეგენი',
    'ოსი',
    'როდა კერკრადე',
    'დე გრაფსხაპი',
    'ტელსტარი',
    'ფოლენდამი',
    'ვენლო'
  ],
  'შოტლანდია პრემიერშიპი': [
    'აბერდინი',
    'სელტიკი',
    'დანდი',
    'დანდი იუნაიტედი',
    'ფალკირკი',
    'ჰარტსი',
    'ჰიბერნიანი',
    'კილმარნოკი',
    'ლივინგსტონი',
    'მაზერუელი',
    'რეინჯერსი',
    'სენტ-მირენი'
  ],
    'ა.შ.შ მლს': [
    'ატლანტა იუნაიტედი',
    'ოსტინი',
    'შარლოტი',
    'ჩიკაგო',
    'კოლორადო',
    'კოლუმბუსი',
    'დისი იუნაიტედი',
    'ფსი სი',
    'სინსინატი',
    'კრიუ',
    'დალასი',
    'დენვერი',
    'დეტროიტი',
    'ჰიუსტონი',
    'ინტერ მაიამი',
    'ლოს-ანჯელესი',
    'ლოს-ანჯელეს გალაქსი',
    'მინესოტა',
    'მონრეალი',
    'ნეშვილი',
    'ნიუ-იორკ სიტი',
    'ნიუ-იორკ რედ ბულზი',
    'ორლანდო',
    'ფილადელფია',
    'პორტლენდი',
    'რეალ სოლტ-ლეიკი',
    'სან-დიეგო',
    'სან-ხოსე',
    'სიეტლი',
    'სპორტინგ კანზასი',
    'ტორონტო',
    'ვანკუვერი'
  ],
  'ბრაზილია სერია ა': [
    'ატლ. მინეირო',
    'ბაჰია',
    'ბოტაფოგო',
    'ბრაგანტინო',
    'კორინთიანსი',
    'კრუზეირო',
    'ფლამენგო',
    'ფლუმინენსე',
    'ფორტალეზა',
    'გრემიო',
    'ინტერნასიონალი',
    'პალმეირასი',
    'სან პაულუ',
    'ვასკო',
    'ვიტორია',
    'ჟუვენტუდე',
    'კრისიუმა',
    'ატლ. გოიანიენსე',
    'სანტოსი',
    'მირასოლი',
    'სპორტი',
    'სეარა'
  ],
  'არგენტინა პრიმერა დივიზიონი': [
    'არგენტინოსი',
    'ატლ. ტუკუმანი',
    'ბანფილდი',
    'ბარაკასი',
    'ბელგრანო',
    'ბოკა',
    'სენტრალ კორდობა',
    'ესტუდიანტესი',
    'ხიმნასია',
    'გოდოი კრუსი',
    'ურაკანი',
    'ინდეპენდიენტე',
    'ინსტიტუტო',
    'ლანუსი',
    'ნიუელსი',
    'პლატენსე',
    'რასინგი',
    'რივერ პლეიტი',
    'როსარიო',
    'სან ლორენსო',
    'სარმიენტო',
    'ტალერესი',
    'ტიგრე',
    'უნიონ სანტა ფე',
    'ველესი',
    'ინდეპ. რივადავია',
    'დეპ. რიესტრა',
    'ალდოსივი',
    'სან მარტინი (სხ)'
  ],
  'ნორვეგია ელიტსერიენი': [
    'აუგლანდი',
    'ბოდე/გლიმტი',
    'ბრანი',
    'ბრინე',
    'ფრედრიკსტადი',
    'ჰაუგესუნდი',
    'ჰამარკამი',
    'კრისტიანსუნდი',
    'ლილესტრომი',
    'მოლდე',
    'ოდდი',
    'სანდეფიორდი',
    'სარფსბორგ 08',
    'სტრიომსგოდსეტი',
    'ტრომსე',
    'ვიკინგი'
  ],
  'შვეიცარია ჩელენჯ ლიგა': [
    'აარაუ',
    'ბელინცონა',
    'კარუჟი',
    'ლოზანა-ოში',
    'ნიონი',
    'რაპერსვილ-იონა',
    'შაფჰაუზენი',
    'ვადუცი',
    'ვინტერტური',
    'ციურიხი'
  ],
  'საუდის არაბეთი პროფედიონალური ლიგა': [
    'ალ-აჰლი',
    'ალ-ფაისალი',
    'ალ-ფაიჰა',
    'ალ-ფარუკი',
    'ალ-ჰილალი',
    'ალ-იტიჰადი',
    'ალ-ხალიჯი',
    'ალ-კაიდია',
    'ალ-კარამა',
    'ალ-კუვაითი',
    'ალ-ნასრი',
    'ალ-ოკდუდი',
    'ალ-რაედი',
    'ალ-ტაი',
    'ალ-ვაჰდა',
    'დამაკი',
    'ჰაზმი',
    'რადი'
  ],
  'უნგრეთი  NB I.': [
    'აკადემია',
    'დებრეცენი',
    'ფერენცვაროში',
    'ფეჰერვარი',
    'ჰონვედი',
    'კაპოშვარი',
    'კეჩკემეტი',
    'მტკიცე',
    'ნირედიჰაზა',
    'პაკში',
    'უიპეშტი',
    'ზალაეგერსეგი'
  ],
  'დანია სუპერლიგა': [
    'აარჰუსი',
    'ბრონდბიუ',
    'კოპენჰაგენი',
    'ჰობრო',
    'ჰორსენსი',
    'მიდტიულანდი',
    'ნორდიულანდი',
    'ოდენსე',
    'რანდერსი',
    'სიონერისკე',
    'ვეილე',
    'ვიბორგი'
  ],
  'შვედეთი ოლსვენკა': [
    'აიკი',
    'ბკ ჰეკენი',
    'ბრომაპოიკარნა',
    'დეგერფორსი',
    'დიურგორდენი',
    'გაისი',
    'ჰალმსტადი',
    'ჰამარბი',
    'მიალბი',
    'მალმიო',
    'ნორჩეპინგი',
    'სირიუსი',
    'ვარნამო',
    'ვესტეროსი',
    'ელფსბორგი',
    'ესტერსი'
  ],
  'რუმინეთი სუპერლიგა': [
    'არგეში',
    'ასტრა ჯურჯუ',
    'ბოტოშანი',
    'ჩიქსერედა',
    'დინამო ბუქარესტი',
    'ფარულ',
    'ფკსბ',
    'ჰერმანშტადტი',
    'ოტელული',
    'პეტროლული',
    'რაპიდ ბუქარესტი',
    'სტეაუა ბუქარესტი',
    'უნივერსიტატეა კრაიოვა',
    'უნივერსიტატეა კლუჟი',
    'უნირეა სლობოზია',
    'ვოლუნტარი'
  ],
  'უკრაინა პრემიერ ლიგა': [
    'ალექსანდრია',
    'დნიპრო-1',
    'დინამო კიევი',
    'ზორია ლუჰანსკი',
    'ინგულეცი',
    'კარპატი ლვივი',
    'კოლოს კოვალივკა',
    'კრივბასი',
    'ლვივი',
    'მეტალისტი',
    'ობოლონი',
    'პოლისია',
    'რუხ ლვივი',
    'შახტარ დონეცკი',
    'ვორსკლა',
    'ჩერნომორეცი'
  ],
  'პოლონეთი ექსტრაკლასა': [
    'იაგელონია',
    'შლიონსკი',
    'ლეგია',
    'პოგონი',
    'ლეხი პოზნანი',
    'გურნიკი',
    'რაკუვი',
    'კატოვიცე',
    'ვიძევი',
    'პიასტი',
    'სტალი',
    'ზაგლებიე',
    'რადომიაკი',
    'კორონა',
    'კრაკოვია',
    'პუშჩა',
    'ლეჩია',
    'მოტორი'
  ],
  'სლოვაკეთი სუპერლიგა': [
    'დაკ 1904 დუნაისკა სტრედა',
    'დუკლა ბანსკა-ბისტრიცა',
    'კოშიცე',
    'ლიპტოვსკი მიკულაში',
    'პოდბრეზოვა',
    'რუჟომბეროკი',
    'სლოვან ბრატისლავა',
    'სპარტაკ ტრნავა',
    'ტრენჩინი',
    'ჟილინა',
    'ზემპლინ მიხალოვცე',
    'ტატრან პრეშოვი'
  ],
  'საბერძნეთი სუპერ ლიგა': [
    'აეკ ათენი',
    'არისი',
    'ატრომიტოსი',
    'ვოლოსი',
    'ლამია',
    'ლევადიაკოსი',
    'ოლიმპიაკოსი',
    'პანაიტოლიკოსი',
    'პანსერაიკოსი',
    'პაოკი',
    'პას იანინა',
    'ასტერას ტრიპოლისი'
  ],
  'კვიპროსი I დივიზიონი': [
    'ანორთოსისი',
    'აპოელი',
    'არისი',
    'აეკ ლარნაკა',
    'დოქსა',
    'ენოსისი',
    'ეთნიკოსი',
    'ევერგეტოულასი',
    'კერავნა',
    'ნეა სალამინა',
    'ომონია',
    'ოლიმპიაკოსი',
    'პაფოსი',
    'პოტია'
  ],
  'ისრაელი პრემიერლიგა': [
    'აშდოდი',
    'ბნეი სახნინი',
    'ჰაპოელ ბეერ-შევა',
    'ჰაპოელ თელ-ავივი',
    'ჰაპოელ ჰაიფა',
    'ჰაპოელ იერუსალიმე',
    'ჰაპოელ პეტაჰ-ტიკვა',
    'ჰაპოელ რაანანა',
    'მაკაბი ბნეი რეინე',
    'მაკაბი თელ-ავივი',
    'მაკაბი ჰაიფა',
    'მაკაბი ნეთანია',
    'მაკაბი პეტაჰ-ტიკვა',
    'სექსია ნეს-ციონა'
  ],
  'ხორვატია HNL': [
    'დინამო ზაგრები',
    'გორიცა',
    'ჰაიდუკი',
    'ისტრა 1961',
    'ლოკომოტივა',
    'ოსიეკი',
    'რიეკა',
    'სლავენ ბელუპო',
    'ვარაჟდინი',
    'შიბენიკი'
  ]
};

// Prediction types organized by category
export const PREDICTION_CATEGORIES = {
  MATCH_RESULT: {
    name: '🏆 მატჩის შედეგი',
    predictions: [
      { value: '1 - სახლის გამარჯვება', label: '1 - სახლის გამარჯვება', type: 'match-result' },
      { value: 'X - ფრე', label: 'X - ფრე', type: 'match-result' },
      { value: '2 - სტუმრის გამარჯვება', label: '2 - სტუმრის გამარჯვება', type: 'match-result' },
      { value: '1X - სახლის გამარჯვება ან ფრე', label: '1X - სახლის გამარჯვება ან ფრე', type: 'match-result' },
      { value: '12 - ერთ-ერთი გუნდის გამარჯვება', label: '12 - ერთ-ერთი გუნდის გამარჯვება', type: 'match-result' },
      { value: 'X2 - სტუმრის გამარჯვება ან ფრე', label: 'X2 - სტუმრის გამარჯვება ან ფრე', type: 'match-result' }
    ]
  },
  GOALS_TOTAL: {
    name: '⚽ გოლების ტოტალი',
    predictions: [
      { value: 'ტოტალი ზევით 0.5', label: 'ტოტალი ზევით 0.5 (მინ. 1 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ზევით 1.5', label: 'ტოტალი ზევით 1.5 (მინ. 2 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ზევით 2.5', label: 'ტოტალი ზევით 2.5 (მინ. 3 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ზევით 3.5', label: 'ტოტალი ზევით 3.5 (მინ. 4 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ზევით 4.5', label: 'ტოტალი ზევით 4.5 (მინ. 5 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ქვევით 0.5', label: 'ტოტალი ქვევით 0.5 (0 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ქვევით 1.5', label: 'ტოტალი ქვევით 1.5 (მაქს. 1 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ქვევით 2.5', label: 'ტოტალი ქვევით 2.5 (მაქს. 2 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ქვევით 3.5', label: 'ტოტალი ქვევით 3.5 (მაქს. 3 გოლი)', type: 'goals-total' },
      { value: 'ტოტალი ქვევით 4.5', label: 'ტოტალი ქვევით 4.5 (მაქს. 4 გოლი)', type: 'goals-total' }
    ]
  },
  BOTH_TEAMS: {
    name: '🎯 ორივე გუნდი',
    predictions: [
      { value: 'GG - ორივე გუნდი გაიტანს გოლს', label: 'GG - ორივე გუნდი გაიტანს გოლს', type: 'both-teams' },
      { value: 'NG - ერთი ან ორივე არ გაიტანს გოლს', label: 'NG - ერთი ან ორივე არ გაიტანს გოლს', type: 'both-teams' },
      { value: 'GG & ზევით 2.5', label: 'GG & ზევით 2.5 (ორივე გაიტანს + 3+ გოლი)', type: 'both-teams' },
      { value: 'GG & ზევით 3.5', label: 'GG & ზევით 3.5 (ორივე გაიტანს + 4+ გოლი)', type: 'both-teams' }
    ]
  },
  HANDICAP: {
    name: '📊 ჰანდიკაპი',
    predictions: [
      { value: 'ჰანდიკაპი 1 (-0.5)', label: 'H1 (-0.5) - სახლის გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 1 (-1)', label: 'H1 (-1) - სახლის 2+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 1 (-1.5)', label: 'H1 (-1.5) - სახლის 2+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 1 (-2)', label: 'H1 (-2) - სახლის 3+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 1 (+0.5)', label: 'H1 (+0.5) - სახლის ფრე ან გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 1 (+1)', label: 'H1 (+1) - სახლის ფრე ან გამარჯვება (+1)', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (-0.5)', label: 'H2 (-0.5) - სტუმრის გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (-1)', label: 'H2 (-1) - სტუმრის 2+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (-1.5)', label: 'H2 (-1.5) - სტუმრის 2+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (-2)', label: 'H2 (-2) - სტუმრის 3+ გოლით გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (+0.5)', label: 'H2 (+0.5) - სტუმრის ფრე ან გამარჯვება', type: 'handicap' },
      { value: 'ჰანდიკაპი 2 (+1)', label: 'H2 (+1) - სტუმრის ფრე ან გამარჯვება (+1)', type: 'handicap' }
    ]
  },
  HALFTIME: {
    name: '⏱️ ტაიმები',
    predictions: [
      { value: '1HT-1 - სახლის 1-ლი ტაიმი გამარჯვება', label: '1HT-1 - სახლის 1-ლი ტაიმი გამარჯვება', type: 'halftime' },
      { value: '1HT-X - 1-ლი ტაიმი ფრე', label: '1HT-X - 1-ლი ტაიმი ფრე', type: 'halftime' },
      { value: '1HT-2 - სტუმრის 1-ლი ტაიმი გამარჯვება', label: '1HT-2 - სტუმრის 1-ლი ტაიმი გამარჯვება', type: 'halftime' },
      { value: '2HT-1 - სახლის 2-ე ტაიმი გამარჯვება', label: '2HT-1 - სახლის 2-ე ტაიმი გამარჯვება', type: 'halftime' },
      { value: '2HT-X - 2-ე ტაიმი ფრე', label: '2HT-X - 2-ე ტაიმი ფრე', type: 'halftime' },
      { value: '2HT-2 - სტუმრის 2-ე ტაიმი გამარჯვება', label: '2HT-2 - სტუმრის 2-ე ტაიმი გამარჯვება', type: 'halftime' },
      { value: '1HT ტოტალი ზევით 0.5', label: '1HT ტოტალი ზევით 0.5 (1+ გოლი პირველ ტაიმში)', type: 'halftime' },
      { value: '1HT ტოტალი ზევით 1.5', label: '1HT ტოტალი ზევით 1.5 (2+ გოლი პირველ ტაიმში)', type: 'halftime' }
    ]
  },
  EXACT_SCORE: {
    name: '🎲 ზუსტი ანგარიში',
    predictions: [
      { value: 'ზუსტი ანგარიში 1:0', label: 'ზუსტი ანგარიში 1:0', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 2:0', label: 'ზუსტი ანგარიში 2:0', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 2:1', label: 'ზუსტი ანგარიში 2:1', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 3:0', label: 'ზუსტი ანგარიში 3:0', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 3:1', label: 'ზუსტი ანგარიში 3:1', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 3:2', label: 'ზუსტი ანგარიში 3:2', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 0:0', label: 'ზუსტი ანგარიში 0:0', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 1:1', label: 'ზუსტი ანგარიში 1:1', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 2:2', label: 'ზუსტი ანგარიში 2:2', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 0:1', label: 'ზუსტი ანგარიში 0:1', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 0:2', label: 'ზუსტი ანგარიში 0:2', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 1:2', label: 'ზუსტი ანგარიში 1:2', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 0:3', label: 'ზუსტი ანგარიში 0:3', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 1:3', label: 'ზუსტი ანგარიში 1:3', type: 'exact-score' },
      { value: 'ზუსტი ანგარიში 2:3', label: 'ზუსტი ანგარიში 2:3', type: 'exact-score' },
      { value: 'სხვა ზუსტი ანგარიში', label: 'სხვა ზუსტი ანგარიში (საკუთარი)', type: 'exact-score' }
    ]
  },
  CARDS_CORNERS: {
    name: '📋 ბარათები & კუთხეები',
    predictions: [
      { value: 'ყვითელი ბარათები ზევით 2.5', label: 'ყვითელი ბარათები ზევით 2.5', type: 'cards-corners' },
      { value: 'ყვითელი ბარათები ზევით 3.5', label: 'ყვითელი ბარათები ზევით 3.5', type: 'cards-corners' },
      { value: 'ყვითელი ბარათები ზევით 4.5', label: 'ყვითელი ბარათები ზევით 4.5', type: 'cards-corners' },
      { value: 'წითელი ბარათი კი', label: 'წითელი ბარათი - კი', type: 'cards-corners' },
      { value: 'წითელი ბარათი არა', label: 'წითელი ბარათი - არა', type: 'cards-corners' },
      { value: 'კუთხური დარტყმები ზევით 8.5', label: 'კუთხური დარტყმები ზევით 8.5', type: 'cards-corners' },
      { value: 'კუთხური დარტყმები ზევით 9.5', label: 'კუთხური დარტყმები ზევით 9.5', type: 'cards-corners' },
      { value: 'კუთხური დარტყმები ზევით 10.5', label: 'კუთხური დარტყმები ზევით 10.5', type: 'cards-corners' },
      { value: 'კუთხური დარტყმები ქვევით 8.5', label: 'კუთხური დარტყმები ქვევით 8.5', type: 'cards-corners' },
      { value: 'კუთხური დარტყმები ქვევით 9.5', label: 'კუთხური დარტყმები ქვევით 9.5', type: 'cards-corners' }
    ]
  }
};

// Legacy flat array for backwards compatibility
export const PREDICTION_TYPES = Object.values(PREDICTION_CATEGORIES)
  .flatMap(category => category.predictions.map(p => p.value));